import React, { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { getManufacturerListDataAPI, insertMasterFromSelect } from '../APICalls';

const SelectWithAddComponent = (props) => {
  const [optionList, setOptionList] = useState([]);
  const [newvalue, setNewvalue] = useState('');
  const { value, formObject, Code, onSelectChange } = props;

  useEffect(() => {
    _getOptionList();
  }, []);

  useEffect(() => {
    if (props.value !== value) {
      //This might cause an infite loop, remove if that happens
      //setValue(props.value);
    }
  }, [props.value, value]);

  const _getOptionList = async () => {
    let list = await getManufacturerListDataAPI();
    setOptionList(list);
  };

  const handleAdd = async () => {
    await insertMasterFromSelect(newvalue);
    await _getOptionList();
    setNewvalue('');
  };

  return (
    <Select
      placeholder="Add/Select Manufacturer"
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider
            style={{
              margin: '8px 0',
            }}
          />
          <Space
            style={{
              padding: '0 8px 4px',
            }}
          >
            <Input
              placeholder="Add new Manufacturer"
              value={newvalue}
              onChange={(e) => setNewvalue(e.target.value)}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={handleAdd}>
              Add
            </Button>
          </Space>
        </>
      )}
      onChange={onSelectChange}
      value={formObject && Code ? formObject[Code] : ''}
      options={
        optionList &&
        Array.isArray(optionList) &&
        optionList.map((item) => ({
          label: item.Name,
          value: item.Name,
        }))
      }
    />
  );
};

export default SelectWithAddComponent;
